namespace Gamification.Texts {

    declare namespace Db {

        namespace Administration {

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const Api: string;
                export const Cognome: string;
                export const DisplayName: string;
                export const Email: string;
                export const IdAzienda: string;
                export const IdAziendaRagioneSociale: string;
                export const IdParent: string;
                export const IdentifierUser: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const Locked: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Nome: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Roles: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace Gamification {

            namespace Api {
                export const Descrizione: string;
                export const IdApi: string;
                export const Nome: string;
            }

            namespace ApiComandi {
                export const Comando: string;
                export const Descrizione: string;
                export const IdApi: string;
                export const IdApiComando: string;
                export const IdApiDescrizione: string;
                export const IdApiNome: string;
                export const IdApiOperazione: string;
                export const IdApiOperazioneDescrizione: string;
                export const IdApiOperazioneIdApiTipoOperazione: string;
                export const IdApiOperazioneIdApiTipoOperazioneNome: string;
                export const IdApiOperazioneNome: string;
            }

            namespace ApiOperazioni {
                export const Area: string;
                export const Descrizione: string;
                export const IdApiOperazione: string;
                export const IdApiTipoOperazione: string;
                export const IdApiTipoOperazioneNome: string;
                export const Nome: string;
            }

            namespace ApiTipiOperazioni {
                export const IdApiTipoOperazione: string;
                export const Nome: string;
            }

            namespace AssetEsperienze {
                export const IdAssetEsperienza: string;
                export const IdAssetEsperienzaOriginal: string;
                export const IdDispositivo: string;
                export const IdDispositivoNome: string;
                export const IdTipologiaEsperienza: string;
                export const IdTipologiaEsperienzaNome: string;
                export const IdentifierAssetEsperienza: string;
                export const IsCloned: string;
                export const Nome: string;
                export const NomeFileAssetBundle: string;
                export const NomeFileCoverAssetBundle: string;
                export const NomeFileManifestAssetBundle: string;
                export const NumeroClassi: string;
                export const PathFileAssetBundle: string;
                export const PathFileCoverAssetBundle: string;
                export const PathFileManifestAssetBundle: string;
                export const TemporaryNomeFileAssetBundle: string;
                export const TemporaryNomeFileCoverAssetBundle: string;
                export const TemporaryNomeFileManifestAssetBundle: string;
                export const TemporaryPathFileAssetBundle: string;
                export const TemporaryPathFileCoverAssetBundle: string;
                export const TemporaryPathFileManifestAssetBundle: string;
                export const TenantId: string;
                export const UrlAssetBundle: string;
                export const UrlCoverAssetBundle: string;
                export const UrlManifestAssetBundle: string;
                export const UserId: string;
                export const VersioneAssetBundle: string;
            }

            namespace AssetEsperienzeRisorse {
                export const IdAssetEsperienza: string;
                export const IdAssetEsperienzaIdDispositivo: string;
                export const IdAssetEsperienzaIdTipologiaEsperienza: string;
                export const IdAssetEsperienzaIdentifierAssetEsperienza: string;
                export const IdAssetEsperienzaNome: string;
                export const IdAssetEsperienzaRisorsa: string;
                export const IdAssetEsperienzaTenantId: string;
                export const IdAssetEsperienzaUrlAssetBundle: string;
                export const IdAssetEsperienzaUrlCoverAssetBundle: string;
                export const IdAssetEsperienzaUserId: string;
                export const IdAssetEsperienzaVersioneAssetBundle: string;
                export const IdRisorsa: string;
                export const IdRisorsaDescrizione: string;
                export const IdRisorsaEscludi: string;
                export const IdRisorsaIdEstensione: string;
                export const IdRisorsaIdTipologiaCaricamento: string;
                export const IdRisorsaIdTipologiaRisorsa: string;
                export const IdRisorsaNome: string;
                export const IdRisorsaTenantId: string;
                export const IdRisorsaUrlAssetBundle: string;
                export const IdRisorsaUrlCoverAssetBundle: string;
                export const IdRisorsaUserId: string;
                export const IdRisorsaVersioneAssetBundle: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Aziende {
                export const IdAzienda: string;
                export const RagioneSociale: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Checklist {
                export const IdAssetEsperienza: string;
                export const IdAssetEsperienzaNome: string;
                export const IdChecklist: string;
                export const Nome: string;
                export const Progressivo: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ChecklistNodi {
                export const IdChecklist: string;
                export const IdChecklistIdAssetEsperienza: string;
                export const IdChecklistNodo: string;
                export const IdChecklistNome: string;
                export const IdChecklistProgressivo: string;
                export const IdNodo: string;
                export const IdNodoAnimationPath: string;
                export const IdNodoCrediti: string;
                export const IdNodoDescrizione: string;
                export const IdNodoExp: string;
                export const IdNodoIdBadge: string;
                export const IdNodoIdClasse: string;
                export const IdNodoIdClasseMissone: string;
                export const IdNodoIdMissione: string;
                export const IdNodoIdRisorsa: string;
                export const IdNodoNome: string;
                export const IdNodoProgressivo: string;
                export const IdNodoPunteggio: string;
                export const IdNodoPunteggioMissioneDropDown: string;
                export const IdNodoPuteggioMissoneTesto: string;
            }

            namespace Credenziali {
                export const Host: string;
                export const IdCredenziale: string;
                export const IdTipologiaCredenziale: string;
                export const IdTipologiaCredenzialeDescrizione: string;
                export const IdTipologiaCredenzialeNome: string;
                export const Nome: string;
                export const Password: string;
                export const TenantId: string;
                export const Token: string;
                export const UserId: string;
                export const Username: string;
            }

            namespace Dispositivi {
                export const Descrizione: string;
                export const IdDispositivo: string;
                export const Nome: string;
                export const Note: string;
                export const UserId: string;
            }

            namespace Estensioni {
                export const Estensione: string;
                export const IdEstensioni: string;
                export const IdTipologiaRisorsa: string;
                export const IdTipologiaRisorsaDescrizione: string;
                export const IdTipologiaRisorsaNome: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Mail {
                export const Bcc: string;
                export const Body: string;
                export const Cc: string;
                export const ErrorMessage: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const LockExpiration: string;
                export const MailFrom: string;
                export const MailId: string;
                export const MailTo: string;
                export const Priority: string;
                export const ReplyTo: string;
                export const RetryCount: string;
                export const SentDate: string;
                export const SerializedMessage: string;
                export const Status: string;
                export const Subject: string;
                export const Uid: string;
            }

            namespace Nodi {
                export const AnimationPath: string;
                export const Crediti: string;
                export const Descrizione: string;
                export const Exp: string;
                export const IdChecklist: string;
                export const IdChecklistNome: string;
                export const IdNodo: string;
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdRisorsa: string;
                export const IdRisorsaNome: string;
                export const IsPunteggioMissioneNegativo: string;
                export const IsPunteggioNodoNegativo: string;
                export const Nome: string;
                export const Progressivo: string;
                export const PunteggioMissione: string;
                export const PunteggioNodo: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Prodotti {
                export const BadgeList: string;
                export const Bozza: string;
                export const ClassiList: string;
                export const CorpoCambiaPassword: string;
                export const CorpoCancellazione: string;
                export const CorpoRegistrazione: string;
                export const CorpoResetPassword: string;
                export const CreditiNome: string;
                export const CreditiValoreIniziale: string;
                export const Descrizione: string;
                export const EsperienzaNome: string;
                export const EsperienzaValoreIniziale: string;
                export const EsperienzeList: string;
                export const IdProdotto: string;
                export const IdTipologiaProdotti: string;
                export const IdTipologiaProdottiDescrizione: string;
                export const IdTipologiaProdottiNome: string;
                export const IdentifierCrediti: string;
                export const IdentifierEsperienza: string;
                export const IdentifierProdotto: string;
                export const IdentifierPunteggio: string;
                export const IsSMTPValido: string;
                export const LinkRegistrazione: string;
                export const LinkResetPassword: string;
                export const LivelliList: string;
                export const Nome: string;
                export const OggettoCambiaPassword: string;
                export const OggettoCancellazione: string;
                export const OggettoRegistrazione: string;
                export const OggettoResetPassword: string;
                export const PunteggioNegativo: string;
                export const PunteggioNome: string;
                export const PunteggioValoreIniziale: string;
                export const SMTPDisplayName: string;
                export const SMTPFrom: string;
                export const SMTPHost: string;
                export const SMTPPassword: string;
                export const SMTPPort: string;
                export const SMTPSecureSocket: string;
                export const SMTPUseSsl: string;
                export const SMTPUseStartTls: string;
                export const SMTPUsername: string;
                export const TenantId: string;
                export const UserId: string;
                export const UserIdNominativo: string;
                export const UserIdRagioneSociale: string;
            }

            namespace ProdottiAssetEsperienze {
                export const IdAssetEsperienza: string;
                export const IdAssetEsperienzaIdDispositivo: string;
                export const IdAssetEsperienzaIdTipologiaEsperienza: string;
                export const IdAssetEsperienzaIdentifierAssetEsperienza: string;
                export const IdAssetEsperienzaNome: string;
                export const IdAssetEsperienzaNomeFileAssetBundle: string;
                export const IdAssetEsperienzaNomeFileAssetPathFile: string;
                export const IdAssetEsperienzaNomeFileCoverAssetBundle: string;
                export const IdAssetEsperienzaPathFileCoverAssetBundle: string;
                export const IdAssetEsperienzaTenantId: string;
                export const IdAssetEsperienzaUrlAssetBundle: string;
                export const IdAssetEsperienzaUrlCoverAssetBundle: string;
                export const IdAssetEsperienzaUserId: string;
                export const IdAssetEsperienzaVersioneAssetBundle: string;
                export const IdProdotto: string;
                export const IdProdottoAssetEsperienza: string;
                export const IdProdottoBozza: string;
                export const IdProdottoCreditiNome: string;
                export const IdProdottoCreditiValoreIniziale: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdProdottoEsperienzaValoreIniziale: string;
                export const IdProdottoIdTipologiaProdotti: string;
                export const IdProdottoIdentifierCrediti: string;
                export const IdProdottoIdentifierEsperienza: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoIdentifierPunteggio: string;
                export const IdProdottoNome: string;
                export const IdProdottoPunteggioNegativo: string;
                export const IdProdottoPunteggioNome: string;
                export const IdProdottoPunteggioValoreIniziale: string;
                export const IdProdottoTenantId: string;
                export const IdProdottoUserId: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiAziende {
                export const IdAzienda: string;
                export const IdAziendaRagioneSociale: string;
                export const IdAziendaTenantId: string;
                export const IdProdotto: string;
                export const IdProdottoAzienda: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoIdTipologiaProdotti: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoNome: string;
                export const IdProdottoTenantId: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiBadge {
                export const Descrizione: string;
                export const IdProdotto: string;
                export const IdProdottoBadge: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoNome: string;
                export const IdentifierBadge: string;
                export const ImmagineNonOttenuto: string;
                export const ImmagineNonOttenutoNomeFile: string;
                export const ImmagineOttenuto: string;
                export const ImmagineOttenutoNomeFile: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiClassi {
                export const Descrizione: string;
                export const IdProdotto: string;
                export const IdProdottoClasse: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoIdTipologiaProdotti: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoNome: string;
                export const IdProdottoTenantId: string;
                export const IdentifierClasse: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiClassiAssetEsperienze {
                export const IdAssetEsperienza: string;
                export const IdAssetEsperienzaNome: string;
                export const IdProdottoClasse: string;
                export const IdProdottoClasseAssetEsperienza: string;
                export const IdProdottoClasseIdProdotto: string;
                export const IdProdottoClasseNome: string;
                export const IdProdottoClasseProdottoNome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiEsperienze {
                export const Bozza: string;
                export const Descrizione: string;
                export const EsperienzaClassiList: string;
                export const IdProdotto: string;
                export const IdProdottoEsperienza: string;
                export const IdentifierEsperienza: string;
                export const IdentifierPunteggioEsperienza: string;
                export const InfluenzaPunteggioGlobale: string;
                export const Nome: string;
                export const NumeroClassi: string;
                export const PunteggioNome: string;
                export const PunteggioValoreIniziale: string;
                export const PunteggioValoreNegativo: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiEsperienzeClassi {
                export const IdProdottoClasse: string;
                export const IdProdottoClasseDescrizione: string;
                export const IdProdottoClasseIdProdotto: string;
                export const IdProdottoClasseIdentifierClasse: string;
                export const IdProdottoClasseNome: string;
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaClasse: string;
                export const IdProdottoEsperienzaDescrizione: string;
                export const IdProdottoEsperienzaIdProdotto: string;
                export const IdProdottoEsperienzaIdentifierEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiEsperienzePunteggi {
                export const Descrizione: string;
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaBozza: string;
                export const IdProdottoEsperienzaDescrizione: string;
                export const IdProdottoEsperienzaIdProdotto: string;
                export const IdProdottoEsperienzaIdentifierEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdProdottoEsperienzaPunteggio: string;
                export const IdProdottoEsperienzaValoreIniziale: string;
                export const IdentifierPunteggio: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
                export const ValoreIniziale: string;
                export const ValoreNegativo: string;
            }

            namespace ProdottiEsperienzeTask {
                export const Descrizione: string;
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaBozza: string;
                export const IdProdottoEsperienzaDescrizione: string;
                export const IdProdottoEsperienzaIdProdotto: string;
                export const IdProdottoEsperienzaIdentifierEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdProdottoEsperienzaTask: string;
                export const IdentifierTask: string;
                export const Nome: string;
            }

            namespace ProdottiLivelli {
                export const IdProdotto: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoIdTipologiaProdotti: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoLivello: string;
                export const IdProdottoNome: string;
                export const IdProdottoTenantId: string;
                export const IdentifierLivello: string;
                export const Nome: string;
                export const Ordine: string;
                export const TenantId: string;
                export const UserId: string;
                export const ValoreMassimo: string;
                export const ValoreMinimo: string;
            }

            namespace ProdottiParametriGlobali {
                export const CreditiNome: string;
                export const CreditiValoreIniziale: string;
                export const IdCrediti: string;
                export const IdProdotto: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoIdTipologiaProdotti: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoNome: string;
                export const IdProdottoParametriGlobali: string;
                export const IdProdottoTenantId: string;
                export const IdPunteggio: string;
                export const PunteggioNegativo: string;
                export const PunteggioNome: string;
                export const PunteggioValoreIniziale: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace ProdottiRisorse {
                export const IdProdotto: string;
                export const IdProdottoBozza: string;
                export const IdProdottoCreditiNome: string;
                export const IdProdottoCreditiValoreIniziale: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdProdottoEsperienzaValoreIniziale: string;
                export const IdProdottoIdTipologiaProdotti: string;
                export const IdProdottoIdentifierCrediti: string;
                export const IdProdottoIdentifierEsperienza: string;
                export const IdProdottoIdentifierProdotto: string;
                export const IdProdottoIdentifierPunteggio: string;
                export const IdProdottoNome: string;
                export const IdProdottoPunteggioNegativo: string;
                export const IdProdottoPunteggioNome: string;
                export const IdProdottoPunteggioValoreIniziale: string;
                export const IdProdottoRisorsa: string;
                export const IdProdottoTenantId: string;
                export const IdProdottoUserId: string;
                export const IdRisorsa: string;
                export const IdRisorsaDescrizione: string;
                export const IdRisorsaEscludi: string;
                export const IdRisorsaIdEstensione: string;
                export const IdRisorsaIdTipologiaCaricamento: string;
                export const IdRisorsaIdTipologiaRisorsa: string;
                export const IdRisorsaNome: string;
                export const IdRisorsaNomeFileAssetBundle: string;
                export const IdRisorsaNomeFileAssetPathFile: string;
                export const IdRisorsaNomeFileCoverAssetBundle: string;
                export const IdRisorsaPathFileCoverAssetBundle: string;
                export const IdRisorsaTenantId: string;
                export const IdRisorsaUrlAssetBundle: string;
                export const IdRisorsaUrlCoverAssetBundle: string;
                export const IdRisorsaUserId: string;
                export const IdRisorsaVersioneAssetBundle: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Raccomandazioni {
                export const Bonus: string;
                export const Condizione: string;
                export const CondizioneVerificata: string;
                export const IdRaccomandazione: string;
                export const Messaggio: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Risorse {
                export const AssetPath: string;
                export const Descrizione: string;
                export const Escludi: string;
                export const IdEstensione: string;
                export const IdRisorsa: string;
                export const IdTipologiaCaricamento: string;
                export const IdTipologiaCaricamentoNome: string;
                export const IdTipologiaRisorsa: string;
                export const IdTipologiaRisorseNome: string;
                export const IdentifierRisorsa: string;
                export const IsUrlAssetBundleEsterno: string;
                export const IsUrlCoverAssetBundleEsterno: string;
                export const IsUrlManifestAssetBundleEsterno: string;
                export const Nome: string;
                export const NomeFileAssetBundle: string;
                export const NomeFileCoverAssetBundle: string;
                export const NomeFileManifestAssetBundle: string;
                export const PathFileAssetBundle: string;
                export const PathFileCoverAssetBundle: string;
                export const PathFileManifestAssetBundle: string;
                export const TenantId: string;
                export const UrlAssetBundle: string;
                export const UrlCoverAssetBundle: string;
                export const UrlManifestAssetBundle: string;
                export const UserId: string;
                export const VersioneAssetBundle: string;
            }

            namespace RisorseChecklist {
                export const IdChecklist: string;
                export const IdChecklistIdAssetEsperienza: string;
                export const IdChecklistNome: string;
                export const IdChecklistProgressivo: string;
                export const IdChecklistTenantId: string;
                export const IdChecklistUserId: string;
                export const IdRisorsa: string;
                export const IdRisorsaChecklist: string;
                export const IdRisorsaDescrizione: string;
                export const IdRisorsaEscludi: string;
                export const IdRisorsaIdEstensione: string;
                export const IdRisorsaIdTipologiaCaricamento: string;
                export const IdRisorsaIdTipologiaRisorsa: string;
                export const IdRisorsaNome: string;
                export const IdRisorsaNomeFileAssetBundle: string;
                export const IdRisorsaNomeFileAssetPathFile: string;
                export const IdRisorsaNomeFileCoverAssetBundle: string;
                export const IdRisorsaPathFileCoverAssetBundle: string;
                export const IdRisorsaTenantId: string;
                export const IdRisorsaUrlAssetBundle: string;
                export const IdRisorsaUrlCoverAssetBundle: string;
                export const IdRisorsaUserId: string;
                export const IdRisorsaVersioneAssetBundle: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace TipologieCaricamenti {
                export const Descrizioni: string;
                export const IdTipologiaCaricamento: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace TipologieCredenziali {
                export const Descrizione: string;
                export const IdTipologiaCredenziale: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace TipologieEsperienze {
                export const Descrizione: string;
                export const IdTipologiaEsperienza: string;
                export const Nome: string;
            }

            namespace TipologieProdotti {
                export const Descrizione: string;
                export const IdTipologiaProdotti: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace TipologieRisorse {
                export const Descrizione: string;
                export const IdTipologiaRisorsa: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace Utenti {
                export const Classi: string;
                export const Cognome: string;
                export const Email: string;
                export const IdProdotto: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoNome: string;
                export const IdUtente: string;
                export const IdentifierUtente: string;
                export const Locked: string;
                export const Nome: string;
                export const Password: string;
                export const TenantId: string;
                export const Token: string;
                export const UserId: string;
            }

            namespace UtentiApi {
                export const Bloccato: string;
                export const IdApi: string;
                export const IdApiDescrizione: string;
                export const IdApiNome: string;
                export const IdUtenteApi: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace UtentiDati {
                export const Api: string;
                export const Bloccato: string;
                export const Cognome: string;
                export const Email: string;
                export const IdAzienda: string;
                export const IdAziendaRagioneSociale: string;
                export const IdUtenteDati: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace UtentiDelegati {
                export const IdUtenteDelegato: string;
                export const UserId: string;
                export const UserIdDelDelegato: string;
                export const UserIdDelDelegatoCognome: string;
                export const UserIdDelDelegatoDisplayName: string;
                export const UserIdDelDelegatoEmail: string;
                export const UserIdDelDelegatoInsertDate: string;
                export const UserIdDelDelegatoInsertUserId: string;
                export const UserIdDelDelegatoIsActive: string;
                export const UserIdDelDelegatoLastDirectoryUpdate: string;
                export const UserIdDelDelegatoMobilePhoneNumber: string;
                export const UserIdDelDelegatoMobilePhoneVerified: string;
                export const UserIdDelDelegatoNome: string;
                export const UserIdDelDelegatoSource: string;
                export const UserIdDelDelegatoTwoFactorAuth: string;
                export const UserIdDelDelegatoUpdateDate: string;
                export const UserIdDelDelegatoUpdateUserId: string;
                export const UserIdDelDelegatoUserImage: string;
                export const UserIdDelDelegatoUsername: string;
            }

            namespace UtentiDelegatiConProprieta {
                export const AdminDisplayName: string;
                export const AdminUsername: string;
                export const Cognome: string;
                export const Email: string;
                export const IdUtenteDelegato: string;
                export const Nome: string;
                export const RagioneSociale: string;
                export const UserDisplayName: string;
                export const UserId: string;
                export const UserIdDelDelegato: string;
                export const UserUserName: string;
            }

            namespace UtentiParametriGlobali {
                export const CreditiNome: string;
                export const CreditiValore: string;
                export const EsperienzaNome: string;
                export const EsperienzaValore: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoParametriGlobali: string;
                export const IdentifierCrediti: string;
                export const IdentifierEsperienza: string;
                export const IdentifierLivello: string;
                export const IdentifierPunteggio: string;
                export const Livello: string;
                export const PunteggioNome: string;
                export const PunteggioValore: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace UtentiProdotti {
                export const Classi: string;
                export const IdProdotto: string;
                export const IdProdottoDescrizione: string;
                export const IdProdottoNome: string;
                export const IdUtente: string;
                export const IdUtenteProdotto: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace UtentiProdottiAlert {
                export const DataOra: string;
                export const IdRaccomandazione: string;
                export const IdRaccomandazioneBonus: string;
                export const IdRaccomandazioneCondizione: string;
                export const IdRaccomandazioneCondizioneVerificata: string;
                export const IdRaccomandazioneMessaggio: string;
                export const IdRaccomandazioneNome: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoAlert: string;
                export const Messaggio: string;
                export const Nome: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace UtentiProdottiBadge {
                export const DataOra: string;
                export const IdProdottoBadge: string;
                export const IdProdottoBadgeDescrizione: string;
                export const IdProdottoBadgeNome: string;
                export const IdUtente: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoBadge: string;
                export const ImmagineOttenuto: string;
                export const ImmagineOttenutoNomeFile: string;
                export const Stato: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace UtentiProdottiClassi {
                export const IdProdottoClasse: string;
                export const IdProdottoClasseNome: string;
                export const IdUtente: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoClasse: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace UtentiProdottiClassifiche {
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoClassifica: string;
                export const IdentifierUtenteProdottoClassifica: string;
                export const Limitazione: string;
                export const Nome: string;
                export const TenantId: string;
                export const Tipo: string;
                export const UserId: string;
            }

            namespace UtentiProdottiConProprieta {
                export const Azienda: string;
                export const Cognome: string;
                export const CognomeAdmin: string;
                export const Email: string;
                export const IdProdotto: string;
                export const IdTipologiaProdotti: string;
                export const IdUtente: string;
                export const IdUtenteProdotto: string;
                export const IdentifierProdotto: string;
                export const IdentifierUtente: string;
                export const Locked: string;
                export const Nome: string;
                export const NomeAdmin: string;
                export const Prodotto: string;
                export const TipologiaProdotti: string;
                export const UserId: string;
            }

            namespace UtentiProdottiEsperienze {
                export const DataOraFine: string;
                export const DataOraInizio: string;
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaDescrizione: string;
                export const IdProdottoEsperienzaIdentifierEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdProdottoEsperienzaPunteggio: string;
                export const IdProdottoEsperienzaPunteggioNome: string;
                export const IdProdottoEsperienzaPunteggioValoreNegativo: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoEsperienza: string;
                export const Stato: string;
                export const TenantId: string;
                export const UserId: string;
                export const Valore: string;
            }

            namespace UtentiProdottiEsperienzeDashboard {
                export const IdProdottoEsperienza: string;
                export const IdProdottoEsperienzaNome: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoEsperienzeDashboard: string;
                export const MiglioreIdUtenteProdottoEsperienza: string;
                export const MigliorePunteggio: string;
                export const MigliorePunteggioData: string;
                export const PeggioreIdUtenteProdottoEsperienza: string;
                export const PeggiorePunteggio: string;
                export const PeggiorePunteggioData: string;
                export const TenantId: string;
                export const UltimoIdUtenteProdottoEsperienza: string;
                export const UltimoPunteggio: string;
                export const UltimoPunteggioData: string;
                export const UserId: string;
            }

            namespace UtentiProdottiEsperienzeTask {
                export const DataOraFine: string;
                export const DataOraInizio: string;
                export const IdProdottoEsperienzaTask: string;
                export const IdProdottoEsperienzaTaskNome: string;
                export const IdUtenteProdottoEsperienza: string;
                export const IdUtenteProdottoEsperienzaDataOraFine: string;
                export const IdUtenteProdottoEsperienzaDataOraInizio: string;
                export const IdUtenteProdottoEsperienzaIdProdottoEsperienza: string;
                export const IdUtenteProdottoEsperienzaIdUtenteProdotto: string;
                export const IdUtenteProdottoEsperienzaStato: string;
                export const IdUtenteProdottoEsperienzaValore: string;
                export const IdUtenteProdottoEsperienzeTask: string;
                export const Stato: string;
                export const TenantId: string;
                export const UserId: string;
            }

            namespace UtentiProdottiParametriGlobali {
                export const CreditiNome: string;
                export const CreditiValore: string;
                export const EsperienzaNome: string;
                export const EsperienzaValore: string;
                export const IdUtenteProdotto: string;
                export const IdUtenteProdottoParametriGlobali: string;
                export const IdentifierCrediti: string;
                export const IdentifierEsperienza: string;
                export const IdentifierLivello: string;
                export const IdentifierPunteggio: string;
                export const Livello: string;
                export const PunteggioNome: string;
                export const PunteggioValore: string;
                export const TenantId: string;
                export const UserId: string;
            }
        }

        namespace _Ext {

            namespace AuditLog {
                export const ActionDate: string;
                export const ActionType: string;
                export const Changes: string;
                export const EntityId: string;
                export const EntityTableName: string;
                export const Id: string;
                export const IpAddress: string;
                export const SessionId: string;
                export const UserId: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    Gamification['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{Language:{Id:1,LanguageId:1,LanguageName:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{Api:1,Cognome:1,DisplayName:1,Email:1,IdAzienda:1,IdAziendaRagioneSociale:1,IdParent:1,IdentifierUser:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,Locked:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Nome:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Roles:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},Gamification:{Api:{Descrizione:1,IdApi:1,Nome:1},ApiComandi:{Comando:1,Descrizione:1,IdApi:1,IdApiComando:1,IdApiDescrizione:1,IdApiNome:1,IdApiOperazione:1,IdApiOperazioneDescrizione:1,IdApiOperazioneIdApiTipoOperazione:1,IdApiOperazioneIdApiTipoOperazioneNome:1,IdApiOperazioneNome:1},ApiOperazioni:{Area:1,Descrizione:1,IdApiOperazione:1,IdApiTipoOperazione:1,IdApiTipoOperazioneNome:1,Nome:1},ApiTipiOperazioni:{IdApiTipoOperazione:1,Nome:1},AssetEsperienze:{IdAssetEsperienza:1,IdAssetEsperienzaOriginal:1,IdDispositivo:1,IdDispositivoNome:1,IdTipologiaEsperienza:1,IdTipologiaEsperienzaNome:1,IdentifierAssetEsperienza:1,IsCloned:1,Nome:1,NomeFileAssetBundle:1,NomeFileCoverAssetBundle:1,NomeFileManifestAssetBundle:1,NumeroClassi:1,PathFileAssetBundle:1,PathFileCoverAssetBundle:1,PathFileManifestAssetBundle:1,TemporaryNomeFileAssetBundle:1,TemporaryNomeFileCoverAssetBundle:1,TemporaryNomeFileManifestAssetBundle:1,TemporaryPathFileAssetBundle:1,TemporaryPathFileCoverAssetBundle:1,TemporaryPathFileManifestAssetBundle:1,TenantId:1,UrlAssetBundle:1,UrlCoverAssetBundle:1,UrlManifestAssetBundle:1,UserId:1,VersioneAssetBundle:1},AssetEsperienzeRisorse:{IdAssetEsperienza:1,IdAssetEsperienzaIdDispositivo:1,IdAssetEsperienzaIdTipologiaEsperienza:1,IdAssetEsperienzaIdentifierAssetEsperienza:1,IdAssetEsperienzaNome:1,IdAssetEsperienzaRisorsa:1,IdAssetEsperienzaTenantId:1,IdAssetEsperienzaUrlAssetBundle:1,IdAssetEsperienzaUrlCoverAssetBundle:1,IdAssetEsperienzaUserId:1,IdAssetEsperienzaVersioneAssetBundle:1,IdRisorsa:1,IdRisorsaDescrizione:1,IdRisorsaEscludi:1,IdRisorsaIdEstensione:1,IdRisorsaIdTipologiaCaricamento:1,IdRisorsaIdTipologiaRisorsa:1,IdRisorsaNome:1,IdRisorsaTenantId:1,IdRisorsaUrlAssetBundle:1,IdRisorsaUrlCoverAssetBundle:1,IdRisorsaUserId:1,IdRisorsaVersioneAssetBundle:1,TenantId:1,UserId:1},Aziende:{IdAzienda:1,RagioneSociale:1,TenantId:1,UserId:1},Checklist:{IdAssetEsperienza:1,IdAssetEsperienzaNome:1,IdChecklist:1,Nome:1,Progressivo:1,TenantId:1,UserId:1},ChecklistNodi:{IdChecklist:1,IdChecklistIdAssetEsperienza:1,IdChecklistNodo:1,IdChecklistNome:1,IdChecklistProgressivo:1,IdNodo:1,IdNodoAnimationPath:1,IdNodoCrediti:1,IdNodoDescrizione:1,IdNodoExp:1,IdNodoIdBadge:1,IdNodoIdClasse:1,IdNodoIdClasseMissone:1,IdNodoIdMissione:1,IdNodoIdRisorsa:1,IdNodoNome:1,IdNodoProgressivo:1,IdNodoPunteggio:1,IdNodoPunteggioMissioneDropDown:1,IdNodoPuteggioMissoneTesto:1},Credenziali:{Host:1,IdCredenziale:1,IdTipologiaCredenziale:1,IdTipologiaCredenzialeDescrizione:1,IdTipologiaCredenzialeNome:1,Nome:1,Password:1,TenantId:1,Token:1,UserId:1,Username:1},Dispositivi:{Descrizione:1,IdDispositivo:1,Nome:1,Note:1,UserId:1},Estensioni:{Estensione:1,IdEstensioni:1,IdTipologiaRisorsa:1,IdTipologiaRisorsaDescrizione:1,IdTipologiaRisorsaNome:1,Nome:1,TenantId:1,UserId:1},Mail:{Bcc:1,Body:1,Cc:1,ErrorMessage:1,InsertDate:1,InsertUserId:1,LockExpiration:1,MailFrom:1,MailId:1,MailTo:1,Priority:1,ReplyTo:1,RetryCount:1,SentDate:1,SerializedMessage:1,Status:1,Subject:1,Uid:1},Nodi:{AnimationPath:1,Crediti:1,Descrizione:1,Exp:1,IdChecklist:1,IdChecklistNome:1,IdNodo:1,IdProdottoEsperienza:1,IdProdottoEsperienzaNome:1,IdRisorsa:1,IdRisorsaNome:1,IsPunteggioMissioneNegativo:1,IsPunteggioNodoNegativo:1,Nome:1,Progressivo:1,PunteggioMissione:1,PunteggioNodo:1,TenantId:1,UserId:1},Prodotti:{BadgeList:1,Bozza:1,ClassiList:1,CorpoCambiaPassword:1,CorpoCancellazione:1,CorpoRegistrazione:1,CorpoResetPassword:1,CreditiNome:1,CreditiValoreIniziale:1,Descrizione:1,EsperienzaNome:1,EsperienzaValoreIniziale:1,EsperienzeList:1,IdProdotto:1,IdTipologiaProdotti:1,IdTipologiaProdottiDescrizione:1,IdTipologiaProdottiNome:1,IdentifierCrediti:1,IdentifierEsperienza:1,IdentifierProdotto:1,IdentifierPunteggio:1,IsSMTPValido:1,LinkRegistrazione:1,LinkResetPassword:1,LivelliList:1,Nome:1,OggettoCambiaPassword:1,OggettoCancellazione:1,OggettoRegistrazione:1,OggettoResetPassword:1,PunteggioNegativo:1,PunteggioNome:1,PunteggioValoreIniziale:1,SMTPDisplayName:1,SMTPFrom:1,SMTPHost:1,SMTPPassword:1,SMTPPort:1,SMTPSecureSocket:1,SMTPUseSsl:1,SMTPUseStartTls:1,SMTPUsername:1,TenantId:1,UserId:1,UserIdNominativo:1,UserIdRagioneSociale:1},ProdottiAssetEsperienze:{IdAssetEsperienza:1,IdAssetEsperienzaIdDispositivo:1,IdAssetEsperienzaIdTipologiaEsperienza:1,IdAssetEsperienzaIdentifierAssetEsperienza:1,IdAssetEsperienzaNome:1,IdAssetEsperienzaNomeFileAssetBundle:1,IdAssetEsperienzaNomeFileAssetPathFile:1,IdAssetEsperienzaNomeFileCoverAssetBundle:1,IdAssetEsperienzaPathFileCoverAssetBundle:1,IdAssetEsperienzaTenantId:1,IdAssetEsperienzaUrlAssetBundle:1,IdAssetEsperienzaUrlCoverAssetBundle:1,IdAssetEsperienzaUserId:1,IdAssetEsperienzaVersioneAssetBundle:1,IdProdotto:1,IdProdottoAssetEsperienza:1,IdProdottoBozza:1,IdProdottoCreditiNome:1,IdProdottoCreditiValoreIniziale:1,IdProdottoDescrizione:1,IdProdottoEsperienzaNome:1,IdProdottoEsperienzaValoreIniziale:1,IdProdottoIdTipologiaProdotti:1,IdProdottoIdentifierCrediti:1,IdProdottoIdentifierEsperienza:1,IdProdottoIdentifierProdotto:1,IdProdottoIdentifierPunteggio:1,IdProdottoNome:1,IdProdottoPunteggioNegativo:1,IdProdottoPunteggioNome:1,IdProdottoPunteggioValoreIniziale:1,IdProdottoTenantId:1,IdProdottoUserId:1,TenantId:1,UserId:1},ProdottiAziende:{IdAzienda:1,IdAziendaRagioneSociale:1,IdAziendaTenantId:1,IdProdotto:1,IdProdottoAzienda:1,IdProdottoDescrizione:1,IdProdottoIdTipologiaProdotti:1,IdProdottoIdentifierProdotto:1,IdProdottoNome:1,IdProdottoTenantId:1,TenantId:1,UserId:1},ProdottiBadge:{Descrizione:1,IdProdotto:1,IdProdottoBadge:1,IdProdottoIdentifierProdotto:1,IdProdottoNome:1,IdentifierBadge:1,ImmagineNonOttenuto:1,ImmagineNonOttenutoNomeFile:1,ImmagineOttenuto:1,ImmagineOttenutoNomeFile:1,Nome:1,TenantId:1,UserId:1},ProdottiClassi:{Descrizione:1,IdProdotto:1,IdProdottoClasse:1,IdProdottoDescrizione:1,IdProdottoIdTipologiaProdotti:1,IdProdottoIdentifierProdotto:1,IdProdottoNome:1,IdProdottoTenantId:1,IdentifierClasse:1,Nome:1,TenantId:1,UserId:1},ProdottiClassiAssetEsperienze:{IdAssetEsperienza:1,IdAssetEsperienzaNome:1,IdProdottoClasse:1,IdProdottoClasseAssetEsperienza:1,IdProdottoClasseIdProdotto:1,IdProdottoClasseNome:1,IdProdottoClasseProdottoNome:1,TenantId:1,UserId:1},ProdottiEsperienze:{Bozza:1,Descrizione:1,EsperienzaClassiList:1,IdProdotto:1,IdProdottoEsperienza:1,IdentifierEsperienza:1,IdentifierPunteggioEsperienza:1,InfluenzaPunteggioGlobale:1,Nome:1,NumeroClassi:1,PunteggioNome:1,PunteggioValoreIniziale:1,PunteggioValoreNegativo:1,TenantId:1,UserId:1},ProdottiEsperienzeClassi:{IdProdottoClasse:1,IdProdottoClasseDescrizione:1,IdProdottoClasseIdProdotto:1,IdProdottoClasseIdentifierClasse:1,IdProdottoClasseNome:1,IdProdottoEsperienza:1,IdProdottoEsperienzaClasse:1,IdProdottoEsperienzaDescrizione:1,IdProdottoEsperienzaIdProdotto:1,IdProdottoEsperienzaIdentifierEsperienza:1,IdProdottoEsperienzaNome:1,TenantId:1,UserId:1},ProdottiEsperienzePunteggi:{Descrizione:1,IdProdottoEsperienza:1,IdProdottoEsperienzaBozza:1,IdProdottoEsperienzaDescrizione:1,IdProdottoEsperienzaIdProdotto:1,IdProdottoEsperienzaIdentifierEsperienza:1,IdProdottoEsperienzaNome:1,IdProdottoEsperienzaPunteggio:1,IdProdottoEsperienzaValoreIniziale:1,IdentifierPunteggio:1,Nome:1,TenantId:1,UserId:1,ValoreIniziale:1,ValoreNegativo:1},ProdottiEsperienzeTask:{Descrizione:1,IdProdottoEsperienza:1,IdProdottoEsperienzaBozza:1,IdProdottoEsperienzaDescrizione:1,IdProdottoEsperienzaIdProdotto:1,IdProdottoEsperienzaIdentifierEsperienza:1,IdProdottoEsperienzaNome:1,IdProdottoEsperienzaTask:1,IdentifierTask:1,Nome:1},ProdottiLivelli:{IdProdotto:1,IdProdottoDescrizione:1,IdProdottoIdTipologiaProdotti:1,IdProdottoIdentifierProdotto:1,IdProdottoLivello:1,IdProdottoNome:1,IdProdottoTenantId:1,IdentifierLivello:1,Nome:1,Ordine:1,TenantId:1,UserId:1,ValoreMassimo:1,ValoreMinimo:1},ProdottiParametriGlobali:{CreditiNome:1,CreditiValoreIniziale:1,IdCrediti:1,IdProdotto:1,IdProdottoDescrizione:1,IdProdottoIdTipologiaProdotti:1,IdProdottoIdentifierProdotto:1,IdProdottoNome:1,IdProdottoParametriGlobali:1,IdProdottoTenantId:1,IdPunteggio:1,PunteggioNegativo:1,PunteggioNome:1,PunteggioValoreIniziale:1,TenantId:1,UserId:1},ProdottiRisorse:{IdProdotto:1,IdProdottoBozza:1,IdProdottoCreditiNome:1,IdProdottoCreditiValoreIniziale:1,IdProdottoDescrizione:1,IdProdottoEsperienzaNome:1,IdProdottoEsperienzaValoreIniziale:1,IdProdottoIdTipologiaProdotti:1,IdProdottoIdentifierCrediti:1,IdProdottoIdentifierEsperienza:1,IdProdottoIdentifierProdotto:1,IdProdottoIdentifierPunteggio:1,IdProdottoNome:1,IdProdottoPunteggioNegativo:1,IdProdottoPunteggioNome:1,IdProdottoPunteggioValoreIniziale:1,IdProdottoRisorsa:1,IdProdottoTenantId:1,IdProdottoUserId:1,IdRisorsa:1,IdRisorsaDescrizione:1,IdRisorsaEscludi:1,IdRisorsaIdEstensione:1,IdRisorsaIdTipologiaCaricamento:1,IdRisorsaIdTipologiaRisorsa:1,IdRisorsaNome:1,IdRisorsaNomeFileAssetBundle:1,IdRisorsaNomeFileAssetPathFile:1,IdRisorsaNomeFileCoverAssetBundle:1,IdRisorsaPathFileCoverAssetBundle:1,IdRisorsaTenantId:1,IdRisorsaUrlAssetBundle:1,IdRisorsaUrlCoverAssetBundle:1,IdRisorsaUserId:1,IdRisorsaVersioneAssetBundle:1,TenantId:1,UserId:1},Raccomandazioni:{Bonus:1,Condizione:1,CondizioneVerificata:1,IdRaccomandazione:1,Messaggio:1,Nome:1,TenantId:1,UserId:1},Risorse:{AssetPath:1,Descrizione:1,Escludi:1,IdEstensione:1,IdRisorsa:1,IdTipologiaCaricamento:1,IdTipologiaCaricamentoNome:1,IdTipologiaRisorsa:1,IdTipologiaRisorseNome:1,IdentifierRisorsa:1,IsUrlAssetBundleEsterno:1,IsUrlCoverAssetBundleEsterno:1,IsUrlManifestAssetBundleEsterno:1,Nome:1,NomeFileAssetBundle:1,NomeFileCoverAssetBundle:1,NomeFileManifestAssetBundle:1,PathFileAssetBundle:1,PathFileCoverAssetBundle:1,PathFileManifestAssetBundle:1,TenantId:1,UrlAssetBundle:1,UrlCoverAssetBundle:1,UrlManifestAssetBundle:1,UserId:1,VersioneAssetBundle:1},RisorseChecklist:{IdChecklist:1,IdChecklistIdAssetEsperienza:1,IdChecklistNome:1,IdChecklistProgressivo:1,IdChecklistTenantId:1,IdChecklistUserId:1,IdRisorsa:1,IdRisorsaChecklist:1,IdRisorsaDescrizione:1,IdRisorsaEscludi:1,IdRisorsaIdEstensione:1,IdRisorsaIdTipologiaCaricamento:1,IdRisorsaIdTipologiaRisorsa:1,IdRisorsaNome:1,IdRisorsaNomeFileAssetBundle:1,IdRisorsaNomeFileAssetPathFile:1,IdRisorsaNomeFileCoverAssetBundle:1,IdRisorsaPathFileCoverAssetBundle:1,IdRisorsaTenantId:1,IdRisorsaUrlAssetBundle:1,IdRisorsaUrlCoverAssetBundle:1,IdRisorsaUserId:1,IdRisorsaVersioneAssetBundle:1,TenantId:1,UserId:1},TipologieCaricamenti:{Descrizioni:1,IdTipologiaCaricamento:1,Nome:1,TenantId:1,UserId:1},TipologieCredenziali:{Descrizione:1,IdTipologiaCredenziale:1,Nome:1,TenantId:1,UserId:1},TipologieEsperienze:{Descrizione:1,IdTipologiaEsperienza:1,Nome:1},TipologieProdotti:{Descrizione:1,IdTipologiaProdotti:1,Nome:1,TenantId:1,UserId:1},TipologieRisorse:{Descrizione:1,IdTipologiaRisorsa:1,Nome:1,TenantId:1,UserId:1},Utenti:{Classi:1,Cognome:1,Email:1,IdProdotto:1,IdProdottoDescrizione:1,IdProdottoNome:1,IdUtente:1,IdentifierUtente:1,Locked:1,Nome:1,Password:1,TenantId:1,Token:1,UserId:1},UtentiApi:{Bloccato:1,IdApi:1,IdApiDescrizione:1,IdApiNome:1,IdUtenteApi:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},UtentiDati:{Api:1,Bloccato:1,Cognome:1,Email:1,IdAzienda:1,IdAziendaRagioneSociale:1,IdUtenteDati:1,Nome:1,TenantId:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},UtentiDelegati:{IdUtenteDelegato:1,UserId:1,UserIdDelDelegato:1,UserIdDelDelegatoCognome:1,UserIdDelDelegatoDisplayName:1,UserIdDelDelegatoEmail:1,UserIdDelDelegatoInsertDate:1,UserIdDelDelegatoInsertUserId:1,UserIdDelDelegatoIsActive:1,UserIdDelDelegatoLastDirectoryUpdate:1,UserIdDelDelegatoMobilePhoneNumber:1,UserIdDelDelegatoMobilePhoneVerified:1,UserIdDelDelegatoNome:1,UserIdDelDelegatoSource:1,UserIdDelDelegatoTwoFactorAuth:1,UserIdDelDelegatoUpdateDate:1,UserIdDelDelegatoUpdateUserId:1,UserIdDelDelegatoUserImage:1,UserIdDelDelegatoUsername:1},UtentiDelegatiConProprieta:{AdminDisplayName:1,AdminUsername:1,Cognome:1,Email:1,IdUtenteDelegato:1,Nome:1,RagioneSociale:1,UserDisplayName:1,UserId:1,UserIdDelDelegato:1,UserUserName:1},UtentiParametriGlobali:{CreditiNome:1,CreditiValore:1,EsperienzaNome:1,EsperienzaValore:1,IdUtenteProdotto:1,IdUtenteProdottoParametriGlobali:1,IdentifierCrediti:1,IdentifierEsperienza:1,IdentifierLivello:1,IdentifierPunteggio:1,Livello:1,PunteggioNome:1,PunteggioValore:1,TenantId:1,UserId:1},UtentiProdotti:{Classi:1,IdProdotto:1,IdProdottoDescrizione:1,IdProdottoNome:1,IdUtente:1,IdUtenteProdotto:1,TenantId:1,UserId:1},UtentiProdottiAlert:{DataOra:1,IdRaccomandazione:1,IdRaccomandazioneBonus:1,IdRaccomandazioneCondizione:1,IdRaccomandazioneCondizioneVerificata:1,IdRaccomandazioneMessaggio:1,IdRaccomandazioneNome:1,IdUtenteProdotto:1,IdUtenteProdottoAlert:1,Messaggio:1,Nome:1,TenantId:1,UserId:1},UtentiProdottiBadge:{DataOra:1,IdProdottoBadge:1,IdProdottoBadgeDescrizione:1,IdProdottoBadgeNome:1,IdUtente:1,IdUtenteProdotto:1,IdUtenteProdottoBadge:1,ImmagineOttenuto:1,ImmagineOttenutoNomeFile:1,Stato:1,TenantId:1,UserId:1},UtentiProdottiClassi:{IdProdottoClasse:1,IdProdottoClasseNome:1,IdUtente:1,IdUtenteProdotto:1,IdUtenteProdottoClasse:1,TenantId:1,UserId:1},UtentiProdottiClassifiche:{IdProdottoEsperienza:1,IdProdottoEsperienzaNome:1,IdUtenteProdotto:1,IdUtenteProdottoClassifica:1,IdentifierUtenteProdottoClassifica:1,Limitazione:1,Nome:1,TenantId:1,Tipo:1,UserId:1},UtentiProdottiConProprieta:{Azienda:1,Cognome:1,CognomeAdmin:1,Email:1,IdProdotto:1,IdTipologiaProdotti:1,IdUtente:1,IdUtenteProdotto:1,IdentifierProdotto:1,IdentifierUtente:1,Locked:1,Nome:1,NomeAdmin:1,Prodotto:1,TipologiaProdotti:1,UserId:1},UtentiProdottiEsperienze:{DataOraFine:1,DataOraInizio:1,IdProdottoEsperienza:1,IdProdottoEsperienzaDescrizione:1,IdProdottoEsperienzaIdentifierEsperienza:1,IdProdottoEsperienzaNome:1,IdProdottoEsperienzaPunteggio:1,IdProdottoEsperienzaPunteggioNome:1,IdProdottoEsperienzaPunteggioValoreNegativo:1,IdUtenteProdotto:1,IdUtenteProdottoEsperienza:1,Stato:1,TenantId:1,UserId:1,Valore:1},UtentiProdottiEsperienzeDashboard:{IdProdottoEsperienza:1,IdProdottoEsperienzaNome:1,IdUtenteProdotto:1,IdUtenteProdottoEsperienzeDashboard:1,MiglioreIdUtenteProdottoEsperienza:1,MigliorePunteggio:1,MigliorePunteggioData:1,PeggioreIdUtenteProdottoEsperienza:1,PeggiorePunteggio:1,PeggiorePunteggioData:1,TenantId:1,UltimoIdUtenteProdottoEsperienza:1,UltimoPunteggio:1,UltimoPunteggioData:1,UserId:1},UtentiProdottiEsperienzeTask:{DataOraFine:1,DataOraInizio:1,IdProdottoEsperienzaTask:1,IdProdottoEsperienzaTaskNome:1,IdUtenteProdottoEsperienza:1,IdUtenteProdottoEsperienzaDataOraFine:1,IdUtenteProdottoEsperienzaDataOraInizio:1,IdUtenteProdottoEsperienzaIdProdottoEsperienza:1,IdUtenteProdottoEsperienzaIdUtenteProdotto:1,IdUtenteProdottoEsperienzaStato:1,IdUtenteProdottoEsperienzaValore:1,IdUtenteProdottoEsperienzeTask:1,Stato:1,TenantId:1,UserId:1},UtentiProdottiParametriGlobali:{CreditiNome:1,CreditiValore:1,EsperienzaNome:1,EsperienzaValore:1,IdUtenteProdotto:1,IdUtenteProdottoParametriGlobali:1,IdentifierCrediti:1,IdentifierEsperienza:1,IdentifierLivello:1,IdentifierPunteggio:1,Livello:1,PunteggioNome:1,PunteggioValore:1,TenantId:1,UserId:1}},_Ext:{AuditLog:{ActionDate:1,ActionType:1,Changes:1,EntityId:1,EntityTableName:1,Id:1,IpAddress:1,SessionId:1,UserId:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}});
}
